import { render } from "./BaseValueMetric.vue?vue&type=template&id=6a6931ab"
import script from "./BaseValueMetric.vue?vue&type=script&lang=js"
export * from "./BaseValueMetric.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BaseValueMetric.vue"]])

export default __exports__